import mapValues from 'lodash/fp/mapValues';
import trim from 'lodash/fp/trim';
import isString from 'lodash/fp/isString';
import isPlainObject from 'lodash/fp/isPlainObject';
import flow from 'lodash/fp/flow';

export const trimData = mapValues((value) => {
  if (isString(value)) {
    return trim(value);
  }

  if (isPlainObject(value)) {
    return trimData(value);
  }

  return value;
});

export const trimFunction = func => flow(trimData, func);
